'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$8() {
  this.bou = null;
  this.bos = null;
  this.bot = false;
  this.boq = null;
  this.bor = false;
  this.bov = false;
  this.bow = false;
  this.bou = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$8 as $c_Lpresto_PrestoRouter$$anon$8 };
$p = $c_Lpresto_PrestoRouter$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$8;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$8() {
}
export { $h_Lpresto_PrestoRouter$$anon$8 as $h_Lpresto_PrestoRouter$$anon$8 };
$h_Lpresto_PrestoRouter$$anon$8.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bou;
});
$p.t = (function() {
  if ((!this.bot)) {
    this.bos = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bot = true;
  }
  return this.bos;
});
$p.ag = (function() {
  if ((!this.bor)) {
    this.boq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bor = true;
  }
  return this.boq;
});
$p.v = (function() {
  if ((!this.bow)) {
    this.bov = false;
    this.bow = true;
  }
  return this.bov;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$8, "presto.PrestoRouter$$anon$8", ({
  OW: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$8 as $d_Lpresto_PrestoRouter$$anon$8 };
//# sourceMappingURL=presto.-Presto-Router$$anon$8.js.map
